<template>
  <div class="signWrap">
    <div class="backBg"></div>
    <div class="container flex col f-center gap-32">
      <div class="signTop">
        <NuxtLink :to="{name: 'index'}" class="logo">
          <img src="~/assets/images/logo_blue.svg" alt="codepresso logo" />
        </NuxtLink>
      </div>
      <LazySignMain v-if="uiType === SignUIType.MAIN" @onClickLogin="onClickLogin" @onClickSignUp="onClickSignUp"/>
      <LazySignForm v-else @on-click-sign-up="onClickSignUp" @on-click-login="onClickLogin"/>
      <LazySignCommonFooter />
    </div>
  </div>
</template>

<script setup lang="ts">
import { SignType, SignUIType } from "~/components/Sign/enum/SignType";

const router = useRouter();
const route = useRoute();

const uiType = ref(SignUIType.MAIN);

const onClickLogin = (type: SignType) => {
  router.push({ query: {uiType: SignUIType.LOGIN, type} })
}

const onClickSignUp = (type: SignType) => {
  router.push({ query: {uiType: SignUIType.SIGNUP, type} })
}

watch(() => route.query.uiType, () => {
  if(route.query.uiType) {
    uiType.value = route.query.uiType as SignUIType;
  }
  else uiType.value = SignUIType.MAIN;
}, { immediate: true })
</script>

<style lang="scss">
@import "~/assets/scss/abstracts/variables.scss";
@import "~/assets/scss/abstracts/mixin.scss";
@import "~/assets/scss/login.scss";
</style>